
/* injects from baggage-loader */

'use strict';

export default class ProductVariantsController {

	constructor($log, $rootScope, $state, $timeout, $window, $stateParams, $uibModal, Product, LoadingCover, Navigation) {
		'ngInject';

		this.$log = $log;
		this.$state = $state;
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.$window = $window;
		this.$stateParams = $stateParams;
		this.$uibModal = $uibModal;
		this.Product = Product;
		this.LoadingCover = LoadingCover;
		this.Navigation = Navigation;

		// Define the loader cover style
		this.loader_style = {
			no_background: true,
			ring_primary_color: '#585858'
		}

		// Update state params
		this.$state.go('.', this.$stateParams, {
			notify: false
		});

		this.products = [];
		this.totalItemCount = 0;

		// Set the default pagination settings
		this.pagination = {
			currentPage: 1,
			pageSize: 1000,
			maxSize: 10
		};

		this.filter = {};

	}

	async $onInit() {

		// Setup loading cover
		this.loadingRequestsLoadingCover = this.LoadingCover.getInstance('product-fieldlog-loader');

		// Override with config pagination settings if available
		this.pagination = this.config.pagination || this.pagination;

		this.filterQuery = {
			equalTo: [{
				key: 'parent',
				value: this.product
			}],
			skip: 0
		}

		// Set the seletec field log from querystring
		if (this.$stateParams.selected) {
			this.filter.selected = this.$stateParams.selected;
			this.selectProduct(this.selectedProduct);
		}

	}

	updateQuerystring() {
		this.$state.go('.', this.filter, {
			notify: false
		});
	}

	clearSelectedProduct() {
		this.selectedProduct = null;
		
		// Update querystring
		this.filter.selected = null;
		this.updateQuerystring();
	}

	async selectProduct(product) {
		// Update querystring
		this.filter.selected = product.id;
		this.updateQuerystring();

		this.selectedProduct = product;
		this.attachmentsMessage = "Loading ...";
		this.selectedProduct.documents = await product.relation('documents').query().find();
		if (!this.selectedProduct.attachments.length) {
			this.attachmentsMessage = "No documents";
		}
		this.$log.debug('product attachments', this.selectedProduct.documents);
		this.$timeout();
	}


	/**
	 * Load the current page of events matching the query
	 */
	loadNextPage() {

		// Update the query
		this.filterQuery.skip = (this.pagination.currentPage * this.pagination.pageSize) - this.pagination.pageSize;
		this.$rootScope.loading_state = true;

		// Update querystring
		this.filter.page = this.pagination.currentPage;
		this.updateQuerystring()

		// Load some more events
		this.Product.query(this.filterQuery).then(results => {

			this.$rootScope.loading_state = false;
			this.products = results;

			// Update the view
			this.$timeout(() => {

				// Scroll to the bottom of the navbar
				this.$window.scrollTo({
					top: 148,
					left: 0,
					behavior: 'smooth'
				});

			}, 100);

		});

	}

	getSelectedProductsMatchingSearch() {
		let items = this.list.getSelectedItems();
		let key = Object.keys(this.searchTerm || {})[0];
		items = items.filter(item => key ? item[key].toLowerCase().includes(this.searchTerm[key]) : true)
	}

	openCreateVariantModal() {
		let modalInstance = this.$uibModal.open({
			animation: true,
			backdrop: 'static',
			component: 'createProductVariantModal',
			resolve: {
				context: () => ({
					product: this.product
				})
			}
		});

		modalInstance.result.then(async res => {
			if (res.productVariant) {
				location.reload()
			}
		}, angular.noop);
	}

}



// WEBPACK FOOTER //
// ./src/app/pages/product/variants/product.variants.controller.js